module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro@2-3d4178d3e388b4760e54545c94ea7ea5.jpg";